import { css } from '@emotion/css'
import { fontSize, fontWeight, spacing, borderRadius, colors, mediaQueryHelper, breakpoint } from '@offerzen/pinata-shame'

const styles = {
  header: css({
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gridTemplateRow: 'auto',
    alignItems: 'center',
    columnGap: spacing.medium,
  }),

  companyImage: css({
    borderRadius: borderRadius.medium,
    padding: spacing.default,
    border: `1px solid ${colors.mystic}`,
    width: 95,
    height: 95,

    img: {
      objectFit: 'contain',
    },
  }),

  details: css({
    display: 'grid',
    rowGap: spacing.small,
  }),

  positionName: css({
    fontSize: fontSize.medium,
    fontWeight: fontWeight.bold,
    color: colors.blackPearl,
    margin: 0,

    [mediaQueryHelper(breakpoint.tablet)]: {
      fontSize: fontSize.large,
    },
  }),

  companyName: css({
    fontSize: fontSize.medium,
    color: colors.scorpion,
    margin: 0,
  }),

  companyProfileLink: css({
    display: 'flex',
    alignItems: 'center',
    gap: spacing.extraSmall,
    margin: 0,
  }),
}

export default styles
